import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Form, Button, Spinner, Modal } from 'react-bootstrap';
import { useToast } from '../../../context/ToastContext';
import logo_white from '../../../assets/images/logo_white.png';
import braUfCities from '../../../assets/json/braUfCities.json';
import { apiSignUp } from '../../../api/api';

const WelcomePopup = ({ show, handleLogin }) => (
  <Modal 
    show={show} 
    backdrop="static"
    keyboard={false}
    fullscreen={false}
    aria-labelledby="contained-modal-title-vcenter"
    centered>
    <Modal.Body >
      <div>
        <h1>Bem-vindo!</h1>
        <p>Agora é só fazer login e ter acesso às melhores bases do mercado.</p>
      </div>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="primary" onClick={handleLogin}>
        FAZER LOGIN
      </Button>
    </Modal.Footer>
  </Modal>
);

const SignUp = () => {
  const [selectedState, setSelectedState] = useState('');
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const { addToast } = useToast();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    cpf: '',
    password: '',
    password2: '',
    terms: false,
    state: '',
    city: ''
  });

  useEffect(() => {
    if (selectedState) {
      const state = braUfCities.find(uf => uf.sigla === selectedState);
      setCities(state ? state.cidades : []);
    } else {
      setCities([]);
    }
  }, [selectedState]);

  const validate = () => {
    const newErrors = [];
    if (!formData.name) newErrors.push('Nome');
    if (!formData.email) newErrors.push('Email');
    if (!formData.phone) newErrors.push('Telefone');
    if (!formData.cpf) newErrors.push('CPF');
    if (!formData.password) newErrors.push('Senha');
    if (!formData.password2) newErrors.push('Confirmação de senha');
    if (!formData.terms) newErrors.push('Termos e condições');
    if (!formData.state) newErrors.push('Estado');
    if (!formData.city) newErrors.push('Cidade');
    return newErrors;
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = validate();
    if (newErrors.length > 0) {
      var msg = newErrors.join(', ');
      addToast('Verifique os campos: '+msg);
    } else {
      setLoading(true);
      try {
        var data = await apiSignUp(formData);
        if (data.ok) {
          setShowPopup(true);
        } else {
          const json = await data.json();
          addToast(json.message); 
        }
      } catch (error) {
        addToast('Usuário e/ou senha inválidos!');
      } finally {
        setLoading(false);
      }
    }
  };

  const handleBack = () => {
    navigate('/');
  };

  return (
    <Container fluid className='app-box-page d-flex flex-column justify-content-center vh-100'>
      <Row>
        <Col md={{ span: 6, offset: 3 }}>
          <Container className='d-flex app-box-container'>
            <Row className='flex-grow-1'>
              <Col md={2} className='d-flex flex-column p-4 app-box-col-left'>
                <img src={logo_white} alt='' />
              </Col>
              <Col md={10} className='d-flex flex-column p-4 app-box-col-right'>
                <Container>
                  <Row>
                    <Col>
                      <Form.Group className="mb-3" controlId="formName">
                        <Form.Label>Nome</Form.Label>
                        <Form.Control
                          type="text"
                          name="name"
                          size="sm"
                          onChange={handleChange}
                          tabIndex="1"
                        />
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group className="mb-3" controlId="formState">
                        <Form.Label>Estado</Form.Label>
                        <Form.Select
                          name="state"
                          size="sm"
                          value={selectedState}
                          onChange={(e) => {
                            handleChange(e);
                            setSelectedState(e.target.value);
                          }}
                          tabIndex="2">
                          <option value=''>Selecione</option>
                          {braUfCities.map((uf, index) => (
                            <option key={uf.sigla} value={uf.sigla}>{uf.sigla + '/' + uf.nome}</option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col>
                      <Form.Group className="mb-3" controlId="formEmail">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                          name="email"
                          type="email"
                          size="sm"
                          placeholder="nome@exemplo.com"
                          onChange={handleChange}
                          tabIndex="4"
                        />
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group className="mb-3" controlId="formCity">
                        <Form.Label>Cidade</Form.Label>
                        <Form.Select
                          name="city"
                          size="sm"
                          disabled={!selectedState}
                          onChange={handleChange}
                          tabIndex="2"
                        >
                          <option value="">Selecione</option>
                          {cities.map((city, index) => (
                            <option key={index} value={city}>{city}</option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col>
                      <Form.Group className="mb-3" controlId="formPhone">
                        <Form.Label>Telefone</Form.Label>
                        <Form.Control
                          type="text"
                          name="phone"
                          size="sm"
                          placeholder="(00) 00000-0000"
                          onChange={handleChange}
                          tabIndex="5"
                        />
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group className="mb-3" controlId="formPass1">
                        <Form.Label>Senha</Form.Label>
                        <Form.Control
                          name="password"
                          type="password"
                          size="sm"
                          placeholder=""
                          onChange={handleChange}
                          tabIndex="6"
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col className='text-center'>
                      <Form.Group className="mb-3" controlId="formCpf">
                        <Form.Label>CPF</Form.Label>
                        <Form.Control
                          name="cpf"
                          type="text"
                          size="sm"
                          placeholder=""
                          onChange={handleChange}
                          tabIndex="8"
                        />
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group className="mb-3" controlId="formPass2">
                        <Form.Label>Confirmar senha</Form.Label>
                        <Form.Control
                          name="password2"
                          type="password"
                          size="sm"
                          placeholder=""
                          onChange={handleChange}
                          tabIndex="7"
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col>
                      <a href="police.html" target="_blank" className=''>Confira aqui nossos termos e condições de uso.</a><br />
                      <Form.Group className="mb-3" controlId="formTerms">
                        <Form.Check
                          name="terms"
                          type="switch"
                          id="custom-switch"
                          className='mt-2'
                          label="Aceito os termos e condições de uso."
                          onChange={handleChange}
                          tabIndex="8"
                        />
                      </Form.Group>
                    </Col>
                  </Row>


                  <Row>
                    <Col className='d-flex justify-content-center'>
                      <Button onClick={handleSubmit} variant="primary" size="sm" className='me-1 w-25' disabled={loading}>
                          {loading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : 'Cadastre-se'}
                      </Button>
                      <Button onClick={handleBack} variant="secondary" size="sm" className='ms-1 w-25'>Voltar</Button>
                    </Col>
                  </Row>

                  <Row>
                    <Col className='text-center text-muted mt-4' style={{ fontSize: 'small' }}>
                      Já possui uma conta?<br />
                      <a href="sign-in" >Entre agora!</a>
                    </Col>
                  </Row>
                </Container>
              </Col>
            </Row>
          </Container>
        </Col>
      </Row>
      <Row>
        <Col md={{ span: 6, offset: 3 }} className='text-center text-muted' style={{ fontSize: 'small' }}>CPUWEB | https://cpuweb.eastus.cloudapp.azure.com | 2025</Col>
      </Row>
      <WelcomePopup show={showPopup} handleLogin={() => navigate('/sign-in')} />
    </Container>
  );
};

export default SignUp;